import React from 'react';

const MicIcon = ({ size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 12.9165C11.8417 12.9165 13.3333 11.4248 13.3333 9.58317V4.99984C13.3333 3.15817 11.8417 1.6665 10 1.6665C8.15834 1.6665 6.66667 3.15817 6.66667 4.99984V9.58317C6.66667 11.4248 8.15834 12.9165 10 12.9165Z" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.625 8.0415V9.45817C3.625 12.9748 6.48333 15.8332 10 15.8332C13.5167 15.8332 16.375 12.9748 16.375 9.45817V8.0415" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.84166 5.35811C9.59166 5.08311 10.4083 5.08311 11.1583 5.35811" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33333 7.1251C9.77499 7.00843 10.2333 7.00843 10.675 7.1251" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 15.8335V18.3335" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>


  );
};

export default MicIcon;
